<template>
  <label class="toggle-switch" :class="{ disabled }">
    <input
      type="checkbox"
      class="toggle-switch-input"
      :checked="modelValue"
      :disabled="disabled"
      @change="$emit('update:modelValue', ($event.target as HTMLInputElement).checked)"
    />
    <span class="toggle-switch-track"><span class="toggle-switch-knob"></span></span>
    <span v-if="$slots.default" class="toggle-switch-label"><slot /></span>
  </label>
</template>

<script setup lang="ts">
defineProps<{
  modelValue: boolean;
  disabled?: boolean;
}>();

defineEmits<{
  'update:modelValue': [value: boolean];
}>();
</script>
